import api from './api'

/**
 * Serviço de Layouts de Grade (AdminTable)
 * Gerencia padrões de colunas salvos por usuário/módulo, com compartilhamento.
 */
export const layoutService = {
  /**
   * Lista os layouts do usuário logado para um módulo (inclui compartilhados com ele).
   * @param {string} modulo - Identificador do módulo (ex: 'MovimentacoesEstoque')
   * @param {Object} [params] - { pageNumber, pageSize }
   */
  listar (modulo, params = {}) {
    const query = new URLSearchParams()
    if (modulo) query.append('modulo', modulo)
    if (params.pageNumber) query.append('pageNumber', params.pageNumber)
    if (params.pageSize) query.append('pageSize', params.pageSize)
    return api.get(`/UserGridLayouts?${query.toString()}`)
  },

  /**
   * Busca o layout default do usuário para o módulo.
   * @param {string} modulo
   * @returns {Promise<{data: object|null}>}
   */
  getDefault (modulo) {
    return api.get(`/UserGridLayouts/default?modulo=${encodeURIComponent(modulo)}`)
  },

  /**
   * Busca um layout por ID (com informações de compartilhamento).
   * @param {number} id
   */
  getById (id) {
    return api.get(`/UserGridLayouts/${id}`)
  },

  /**
   * Cria um novo layout.
   * @param {Object} data - { modulo, nome, isDefault, configuracaoColunas, sortField, sortOrder }
   */
  criar (data) {
    return api.post('/UserGridLayouts', data)
  },

  /**
   * Atualiza um layout (apenas dono).
   * @param {number} id
   * @param {Object} data
   */
  atualizar (id, data) {
    return api.put(`/UserGridLayouts/${id}`, data)
  },

  /**
   * Exclui um layout (apenas dono).
   * @param {number} id
   */
  excluir (id) {
    return api.delete(`/UserGridLayouts/${id}`)
  },

  /**
   * Define um layout como default do usuário para o módulo.
   * @param {number} id
   */
  setDefault (id) {
    return api.post(`/UserGridLayouts/${id}/set-default`)
  },

  /**
   * Compartilha um layout com outros usuários.
   * @param {Object} data - { idUserGridLayout, idsUsuarios, isCopia }
   */
  compartilhar (data) {
    return api.post('/UserGridLayouts/compartilhar', data)
  },

  /**
   * Remove um compartilhamento.
   * @param {number} idCompartilhamento
   */
  removerCompartilhamento (idCompartilhamento) {
    return api.delete(`/UserGridLayouts/compartilhar/${idCompartilhamento}`)
  },

  /**
   * Lista com quem o layout está compartilhado.
   * @param {number} idLayout
   */
  listarCompartilhados (idLayout) {
    return api.get(`/UserGridLayouts/${idLayout}/compartilhados`)
  },

  /**
   * Lista usuários da mesma empresa disponíveis para compartilhar.
   */
  listarUsuariosDisponiveis () {
    return api.get('/UserGridLayouts/usuarios-disponiveis')
  }
}
